// extracted by mini-css-extract-plugin
export var closeButton = "_2e-3";
export var header = "_2e-0";
export var link = "_2e-1";
export var retryButton = "_2e-2";